import {
  createDomainApi,
  type ExtractEntityType,
  type ExtractInputType,
} from '@skylabs-digital/react-proto-kit';
import { appInputSchema, appSchema } from '../schemas/app.schema';

export const appsApi = createDomainApi('apps', appSchema, appInputSchema);

export type AppEntity = ExtractEntityType<typeof appsApi>;
export type AppInputType = ExtractInputType<typeof appsApi>;
